import { render } from "./Sidebar.vue?vue&type=template&id=5a28393f&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5a28393f&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=5a28393f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a28393f"]])

export default __exports__